import { useMutation } from '@apollo/client/react';
import { gql } from '@apollo/client';

const INVITE_USER_MUTATION = gql`
  mutation InviteUserToProject($input: InviteUserToProjectInput!) {
    inviteUserToProject(input: $input) {
      invitation {
        id
        email
        status
        expiresAt
        projectName
        inviterName
      }
      projectMembership {
        id
        user {
          id
          email
          fullName
        }
      }
    }
  }
`;

export type InviteUserToProjectResult = {
  addedDirectly: boolean;
  invitation?: {
    id: string;
    email: string;
    status: string;
    expiresAt: string;
    projectName: string;
    inviterName: string;
  };
  projectMembership?: {
    id: string;
    user: {
      id: string;
      email: string;
      fullName: string;
    };
  };
};

export function useInviteUser() {
  const [inviteUserMutation, { loading, error }] = useMutation(INVITE_USER_MUTATION);

  const inviteUser = async (
    projectId: string,
    email: string
  ): Promise<InviteUserToProjectResult> => {
    const { data } = await inviteUserMutation({
      variables: {
        input: { projectId, email },
      },
    });

    const payload = (data as any)?.inviteUserToProject;

    return {
      addedDirectly: !!payload?.projectMembership,
      invitation: payload?.invitation ?? undefined,
      projectMembership: payload?.projectMembership ?? undefined,
    };
  };

  return { inviteUser, loading, error };
}